import React from 'react';
import {
  Title, Text, Spacer
} from 'components/atoms';
import styled, { css } from 'styled-components/macro';
import { useParams } from 'react-router-dom'
import { PermissionsListPage } from 'containers';

const EditorPermissions = () => {
  const { pageId, subweb } = useParams()

  return (
    <>
      <Wrapper>
        <Top>
          <Top.Header>
            <Title modifiers={['fixMarginBottom']}>Permissões</Title>
          </Top.Header>
          <Spacer top="xs" />
          <Text modifiers={['content']}>
            Utilizadores com permissões para editar apenas esta página.
          </Text>
        </Top>
        <End>
          <PermissionsListPage
            subweb={subweb}
            pageId={pageId}
          />
        </End>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div(props => css`
  padding-bottom:  ${props.theme.spacing.xl3};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${props => props.theme.colors.bgLighterS};
  overflow-y: auto;
  max-height: calc(100vh - 90px);
`)

const Top = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${props => props.theme.spacing.xl};
  padding-bottom: ${props => props.theme.spacing.m};
  padding-right: ${props => props.theme.spacing.xl};
  padding-left: ${props => props.theme.spacing.xl3}
`;

Top.Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const End = styled.div`
  padding-bottom: ${props => props.theme.spacing.m};
  padding-right: ${props => props.theme.spacing.xl};
  padding-left: ${props => props.theme.spacing.xl3};
`

export default EditorPermissions;
